import React from 'react';
import { Col, Row, Segmented } from 'antd';
import { BackspaceRounded } from "@mui/icons-material";
import Slider from '@mui/material/Slider';
import { InputNumber } from 'antd';
import { ScreenerTypeIcon, screenerFieldToName } from './screensConfig';
import { stringMixin } from '../../utils/strings';

const ScreenerControl = ({ metric, metricData, filterValues, onClear, onConditionChange, onValueChange }) => {
    return (
        <div style={{ padding: '10px 0', borderBottom: '1px solid #ededed', marginBottom: '15px' }}>
            <Row justify="space-between" align="middle">
                <Col span={14}>
                    <span style={{ fontFamily: 'var(--font-title)', fontSize: '12px', fontWeight: '500', textTransform: "uppercase" }}>
                        <ScreenerTypeIcon type={metricData.type} />
                        {`${screenerFieldToName?.(metric)}`}
                    </span>
                </Col>
                <Col style={{ width: '40px' }}>
                    <BackspaceRounded onClick={() => onClear(metric)} style={{ fontSize: '13px', cursor: 'pointer' }} />
                </Col>
            </Row>
            <Row gutter={8} align="middle">
                <Col span={8}>
                    <Segmented
                        defaultValue={filterValues[metric].condition}
                        style={{ width: '100%' }}
                        onChange={(newCondition) => onConditionChange(metric, newCondition)}
                        options={[
                            { value: 'greater', label: '>' },
                            { value: 'less', label: '<' },
                            { value: 'range', label: '| |' }
                        ]}
                        size={'small'}
                    />
                </Col>
                <Col span={12}>
                    <Row align={'top'} wrap={false} gutter={12}>
                        <Col span={12}>
                            <Slider
                                range={filterValues[metric].condition === 'range'}
                                value={filterValues[metric].value}
                                onChange={(_, newValue) => onValueChange(metric, newValue)}
                                min={metricData.min}
                                max={metricData.max}
                                step={metricData.step ?? 1}
                                size={'small'}
                                marks={[
                                    { value: metricData.min, label: stringMixin.largeNumber(metricData.min) },
                                    { value: metricData.max, label: stringMixin.largeNumber(metricData.max) }
                                ]}
                                style={{
                                    fontSize: '10px',
                                }}
                            />
                        </Col>
                        <Col>
                            <InputNumber
                                value={filterValues[metric].value}
                                onChange={(value) => onValueChange(metric, value)}
                                style={{ width: '100%', border: 'none', textAlign: 'center' }}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
};

export default ScreenerControl;
